import { Paragraph, Separator } from '@fs/zion-ui'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import { FormCheckbox } from '@fs/zion-form'

/**
 * TreeLegalTerms - Needs to be in a ZionForm.
 *
 * @param {object} Props - Props
 * @param {boolean} Props.isResearcherGroup - isResearcherGroup
 * @returns {JSX.Element} -
 */
export default function TreeLegalTerms({ isResearcherGroup }) {
  const [t] = useTranslation()

  return (
    <>
      <Paragraph size="xs">
        {!isResearcherGroup ? (
          t('group-management.join.group-privacy-2.description')
        ) : (
          <Trans
            i18nKey={
              isResearcherGroup
                ? 'group-management.join.researcher-group-privacy.description'
                : 'group-management.join-group-privacy.description'
            }
          >
            <Link target="_blank" to="https://www.familysearch.org/legal/familysearch-content-submission-agreement" />
            <Link target="_blank" to="https://www.familysearch.org/legal/terms" />
            <Link target="_blank" to="https://www.familysearch.org/legal/privacy" />
          </Trans>
        )}
      </Paragraph>

      <Separator size="xxs" />

      <FormCheckbox
        data-testid="agree-join-checkbox-tree1"
        name="agreeJoinCheckTree1"
        label={
          <Trans i18nKey="group-management.join.terms-check">
            <Link target="_blank" to="https://www.familysearch.org/legal/familysearch-content-submission-agreement" />
            <Link target="_blank" to="https://www.familysearch.org/legal/terms" />
            <Link target="_blank" to="https://www.familysearch.org/legal/privacy" />
          </Trans>
        }
      />
      <FormCheckbox
        data-testid="agree-join-checkbox-tree2"
        name="agreeJoinCheckTree2"
        label={t(
          isResearcherGroup
            ? 'group-management.join.researcher-right-check.description'
            : 'group-management.join.right-check'
        )}
      />
    </>
  )
}
